import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import Sidebar from './Sidebar';
import '../styles/MainLayout.css';

const MainLayout = ({ user, onLogout, children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // 사용자 계정 상태 실시간 모니터링
  useEffect(() => {
    if (!user || !user.id) return;

    const unsubscribe = onSnapshot(
      doc(db, 'users', user.id),
      (doc) => {
        if (!doc.exists()) {
          // 계정이 삭제된 경우
          alert('계정이 삭제되어 로그아웃됩니다.');
          onLogout();
          navigate('/');
        }
      },
      (error) => {
        console.error('사용자 계정 모니터링 오류:', error);
      }
    );

    return () => unsubscribe();
  }, [user, onLogout, navigate]);

  // 현재 경로를 기반으로 활성 페이지 결정
  const getCurrentPage = () => {
    const path = location.pathname;
    if (path === '/dashboard') return 'home';
    if (path === '/schedule/register') return 'register';
    if (path === '/profile') return 'profile';
    if (path === '/schedule/all') return 'all-schedule';
    if (path === '/tutor/management') return 'tutor-manage';
    if (path === '/backup') return 'backup';
    return 'home';
  };

  const handlePageChange = (pageId, path) => {
    navigate(path);
  };

  return (
    <div className="main-layout">
      <Sidebar 
        user={user}
        currentPage={getCurrentPage()}
        onPageChange={handlePageChange}
        onLogout={onLogout}
      />
      <div className="main-content">
        <div className="content-wrapper">
          {children}
        </div>
      </div>
    </div>
  );
};

export default MainLayout; 